/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

const selectors = {
  productSpecs: document.querySelector('[data-product-specs]'),
  productSpecsToggle: document.querySelector('[data-product-specs-toggle]'),
  reviewsQaLabel: () => document.querySelector('.reviews-qa-label'),
  reviewsQaWrapper: () => document.querySelector('.bottom-line-items'),
};

const productPage = {
  init: () => {
    if (selectors.productSpecsToggle) {
      selectors.productSpecsToggle.addEventListener('click', () => {
        if (selectors.productSpecs.classList.contains('is-hidden')) {
          selectors.productSpecs.classList.remove('is-hidden');
          selectors.productSpecsToggle.ariaExpanded = 'true';
          return;
        }
        selectors.productSpecs.classList.add('is-hidden');
        selectors.productSpecsToggle.ariaExpanded = 'false';
      });
    }
    productPage.checkIfYotpoLoaded().then((yotpo) => {
      const numberOfReviews = parseInt(yotpo.innerHTML.split(' ')[0], 10);
      const reviewStarsWrapper = selectors.reviewsQaWrapper();
      if (numberOfReviews < 1) {
        reviewStarsWrapper.style.display = 'none';
      }
    });
  },
  checkIfYotpoLoaded: () => {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (selectors.reviewsQaLabel()) {
          resolve(selectors.reviewsQaLabel());
          clearInterval(checkInterval);
        }
      }, 200);
    });
  },
};

productPage.init();

export default productPage;
